// modules/ads-stats/useSelectableTotal.ts
// Хук для вибіркового Total-рядка в таблицях звіту.
// Застосовується однаково на всіх табах (Ads/Campaigns/Geo/Accounts/Creative).

import { useState,useCallback } from 'react';

/**
 * Керування вибраними рядками для динамічного Total.
 *
 * @param rows       — поточні відфільтровані+відсортовані рядки таблиці
 * @param getRowKey  — функція, що повертає унікальний ключ рядка
 *
 * Якщо жоден рядок не вибраний (selectedKeys порожній) — activeRows === rows
 * (Total по ВСІХ рядках, поточна поведінка за замовчуванням).
 * Якщо є вибір — activeRows містить лише вибрані рядки.
 */
export function useSelectableTotal<T>(
  rows: T[],
  getRowKey: (r: T) => string
) {
  const [selectedKeys, setSelectedKeys] = useState<Set<string>>(new Set());

  const toggle = (key: string) =>
    setSelectedKeys((old) => {
      const next = new Set(old);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });

  const reset = useCallback(() => setSelectedKeys(new Set<string>()),[]);

  const isSelected = (key: string) => selectedKeys.has(key);

  // Якщо нічого не вибрано — Total по ВСІХ рядках;
  // якщо є вибір — Total ЛИШЕ по вибраних.
  const activeRows =
    selectedKeys.size > 0
      ? rows.filter((r) => selectedKeys.has(getRowKey(r)))
      : rows;

  return {
    toggle,
    reset,
    isSelected,
    activeRows,
    hasSelection: selectedKeys.size > 0,
  };
}
